module.exports = __webpack_public_path__ + "img/non_active.775fcb05.svg";